module.exports = __webpack_public_path__ + "media/images/comment_arrow-7ca9832a94204b9a74039ec6a116adb2.gif";